import React, { useEffect, useState } from 'react';

export const SgXBRLPromoBanner: React.FC = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const DISMISS_KEY = 'sg_xbrl_promo_banner_dismissed_v1';

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (!dismissed) {
      setShouldShow(true);
    }
  }, []);

  const dismissBanner = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setShouldShow(false);
  };

  if (!shouldShow) {
    return null;
  }

  return (
    <div>
      <div className="w-full bg-blue-600 text-white py-3 px-4 shadow-md mb-4 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 flex-1 min-w-0">
            <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-sm font-medium truncate">
              Singapore XBRL filing special price is now available.
              <button
                onClick={() => setShowModal(true)}
                className="ml-2 underline hover:no-underline font-semibold"
              >
                More info
              </button>
            </p>
          </div>

          <button
            onClick={dismissBanner}
            className="flex-shrink-0 bg-blue-700 hover:bg-blue-800 text-white px-3 py-1.5 rounded-md text-sm font-medium"
          >
            Dismiss
          </button>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full overflow-hidden">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-lg font-semibold text-gray-900">Singapore XBRL Pricing</h3>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200">
                    Limited discount
                  </span>
                </div>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                  aria-label="Close pricing modal"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <p className="text-sm text-gray-600 mb-4">
                Current promotional price for Singapore filings:
              </p>

              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left py-2.5 px-3 font-medium text-gray-700">Product</th>
                      <th className="text-right py-2.5 px-3 font-medium text-gray-700">Original</th>
                      <th className="text-right py-2.5 px-3 font-medium text-green-700">Discounted</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr className="border-t border-gray-100">
                      <td className="py-2.5 px-3">Full XBRL</td>
                      <td className="text-right py-2.5 px-3 text-gray-500 line-through">25.00 SGD</td>
                      <td className="text-right py-2.5 px-3 font-semibold text-green-700">15.00 SGD</td>
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="py-2.5 px-3">Simplified XBRL</td>
                      <td className="text-right py-2.5 px-3 text-gray-500 line-through">10.00 SGD</td>
                      <td className="text-right py-2.5 px-3 font-semibold text-green-700">7.50 SGD</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => setShowModal(false)}
                  className="f-btn f-btn-primary"
                >
                  Understood
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
